import React, { useState } from 'react';
import useTimeout from 'react-use/lib/useTimeout.js';
import { trackingService } from 'services/tracking/TrackingService.js';
import { useNavigationFrameContext } from 'contexts/NavigationFrameContext.jsx';
import useProductDataOutsideRoutes from 'hooks/useProductDataOutsideRoutes.js';
import { OrgSelectorAndGLobalProductSwitcherRow, ProductMenu } from './styles.js';
import GlobalProductMenu from '../GlobalProductMenu/index.jsx';
import OrgListSelector from './OrgListSelector.jsx';
import OrgProductList from './OrgProductList.jsx';

const ExpandedProductHeader = ({ ref, organizations, handleProductMenuOpen, ...props }) => {
  const { setIsProductHeaderExpanded } = useNavigationFrameContext();
  const { selectedProduct, orgId } = useProductDataOutsideRoutes();
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [isReady, cancel, resetTimeout] = useTimeout(300);

  const handleWorkspaceSelect = (workspace) => {
    resetTimeout();
    setSelectedOrg(workspace);
  };

  const closeMenuOnGlobalProductSwitch = () => {
    setIsProductHeaderExpanded(false);
    trackingService.track({
      eventType: 'product-menu:close',
      trigger: 'global-product-switch',
    });
  };

  const hasOrganizations = organizations?.length > 0;
  const hasMoreThanOneOrganization = organizations?.length > 1;

  return (
    <ProductMenu layout {...props}>
      <OrgSelectorAndGLobalProductSwitcherRow layout>
        {hasMoreThanOneOrganization && (
          <OrgListSelector organizations={organizations} onSelect={(org) => handleWorkspaceSelect(org)} orgId={orgId} />
        )}
        <GlobalProductMenu closeMenu={closeMenuOnGlobalProductSwitch} />
      </OrgSelectorAndGLobalProductSwitcherRow>
      {hasOrganizations && (
        <OrgProductList
          selectedOrg={selectedOrg}
          selectedProduct={selectedProduct}
          currentOrg={organizations.find((org) => org.id === orgId)}
          selectingProduct={() => handleProductMenuOpen('selecting-product')}
          showSkeleton={!isReady()}
        />
      )}
    </ProductMenu>
  );
};

export default React.forwardRef((props, ref) => <ExpandedProductHeader {...props} ref={ref} />);
